import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=f78b2106&"
import script from "./Users.vue?vue&type=script&lang=ts&"
export * from "./Users.vue?vue&type=script&lang=ts&"
import style0 from "./Users.vue?vue&type=style&index=0&id=f78b2106&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports